module.exports = __webpack_public_path__ + "img/com41.2483f3f4.png";